// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ic3D","col":"styles_col__I__Lb"};